<template>
  <div>
    <div class="one">
      <div class="two">
        <span>数据类别的定义:</span>
        <el-row>
          <el-col :span="24">
            <div style="line-height: 20px">
              <p style="text-align: justify;font-size:16px">
                明确数据类别的定义有助于有效分类和筛选天文数据，以便更准确地研究和识别有趣的天文目标。我们目前将现有的数据划分为以下几个类别（异常扩展天体；已知扩展天体：椭圆星系、旋涡星系、侧向星系；噪声、杂点数据）：
              </p>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="padding-top:20px;">
        <h2>异常扩展天体:</h2>
        <p>异常扩展天体（或异常源）通常指的是与<b>已知扩展天体</b>不同的天体或天文现象，包括不规则星系、merger星系、致密星系、强引力透镜 等罕见的天体类型或表现出特殊行为的天体 <b @click="fun"
            style="color:rgb(10,108,255);cursor: pointer;">（见已知范例）</b>。</p>
      </div>

      <div style="margin-top:10px;">
        <h2>已知扩展天体：</h2>
        <p> <b>椭圆星系(Elliptical Galaxy):</b>椭圆星系通常呈现出较为规则的形态，没有明显的旋臂结构，主要由老化的恒星组成。它们的光度分布呈现出类似椭圆形的等光度等值线，颜色一般更倾向于黄色和红色。
        </p>
        <div class="image1">
          <div><img src="../assets/img/1.jpg" alt=""></div>
        </div>
      </div>

      <div style="margin-top:-70px;">
        <p> <b>旋涡星系(Spiral Galaxy):</b>旋涡星系具有明显的旋臂结构，通常由年轻的恒星组成，含有大量的气体和尘埃。颜色一般更倾向于蓝色。</p>
        <div class="image1">
          <div><img src="../assets/img/2.jpg" alt=""></div>
        </div>
      </div>

      <div style="margin-top:-70px;">
        <p>
          <b>侧向星系：</b>在天文学中，侧向星系是一种用来描述星系或其他天体观测视角的术语。侧向星系表示天体的主轴（通常是星系的盘面）与观测者的视线几乎垂直，导致我们无法看到星系的盘面，而只能观察到星系的边缘轮廓，通常该星系呈现为一条线段或椭圆形。
        </p>
        <div class="image1">
          <div><img src="../assets/img/3.jpg" alt=""></div>
        </div>
      </div>

      <div style="margin-top:-50px;">
        <div>
          <h2>噪声、杂点数据:</h2>
        </div>
        <div>
          <p>该类型数据通常分为以下几种类：</p>
        </div>
        <p> <b>中心没有扩展天体的数据（1-3：没有天体的数据，7-9：中心是恒星数据）：</b> 这类数据对应于图像中没有明显可见的中心天体或者中心天体是恒星。在分类中，通常将它们视为无效数据点。</p>
        <p> <b>受分辨率、噪声影响没办法判断类别的数据（4-6）：</b> 这类数据可能由于图像的分辨率限制或噪声等因素而无法准确分类。在分类中，通常将它们视为无效数据点。</p>
        <p> <b>受条带、恒星影响的没有办法判断类别的数据（10-12）：</b> 这类数据可能受到来自条带状干扰或恒星光污染的影响，使其难以准确分类。在分类中，通常将它们视为无效数据点。</p>

        <div class="image2">
          <div><img src="../assets/img/4.jpg" alt=""></div>
        </div>
      </div>

      <!-- 回到顶部 -->
      <el-backtop :visibility-height="50" :bottom="120">
      </el-backtop>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fanli: true
    }
  },
  methods: {
    fun () {
      this.$emit("pass", this.fanli)
    }
  }
}
</script>

<style lang="scss" scoped>
.one {
  // display: flex;
  // justify-content: space-between;
  width: 95%;
  height: 100%;
  color: rgb(44, 62, 80);

  p {
    // 文本两端对齐
    text-align: justify;
    font-size: 16px;
  }
}

.two {
  span {
    font-size: 38px;
    color: rgb(44, 62, 80);
  }
}

p {
  font-size: 1.3vw;
  margin-top: 10px;
  text-indent: 2em;
  line-height: 30px;
}

img {
  width: 70%;
  height: auto;
}

.morphology {
  width: calc(120% - 10px);
  height: auto;
}

.img-one {
  width: calc(100% - -5px);
  height: auto;
}

.img-two {
  width: 70%;
  height: auto;
}

.image {
  width: 500px;
  height: 300px;

  img {
    width: 240px;
    height: 200px;
  }

  .imga {
    width: 420px;
    height: 200px;
  }
}

.image1 {
  width: 100%;
  height: 410px;
  padding-left: 85px;

  img {
    margin: 10px 0px;
    width: 800px;
    height: 330px;
  }
}

.image2 {
  width: 100%;
  height: 300px;
  padding-left: 85px;

  img {
    width: 800px;
    height: 280px;
  }
}
</style>